import { TronAddress } from '@src/types/token'
import { walletLogger } from '@src/utils/logger'
import { getTronAllowance } from '@src/utils/tron/utils'

export const getTronChainAllowance = async (address: TronAddress, owner: string, spender: string): Promise<bigint> => {
    try {
        const allowance = await getTronAllowance(address, owner, spender)
        return BigInt(allowance)
    } catch (error) {
        walletLogger.error('Error checking Tron allowance:', { error })
        return BigInt(0)
    }
}
